import "./GetInTouch.css";
import useGetInTouch from "./useGetInTouch";

const GetInTouch = ({ data }: { data: any }) => {
  const { onSubmit, register, isValid, handleSubmit } = useGetInTouch();
  return (
    <section className="get-in-touch-section" id="get-in-touch">
      <h2 className="get-in-touch-title">{data?.header}</h2>

      <div className="get-in-touch-container">
        <div className="get-in-touch-image">
          <div className="image-column">
            <img
              src={data?.images[0]}
              alt="img1"
              className="touch-image small"
            />
            <img src={data?.images[1]} alt="img2" className="touch-image big" />
          </div>
          <div className="image-column">
            <img src={data?.images[2]} alt="img3" className="touch-image big" />
            <img
              src={data?.images[3]}
              alt="img4"
              className="touch-image small"
            />
          </div>
          <div className="image-column">
            <img
              src={data?.images[4]}
              alt="img5"
              className="touch-image small"
            />
            <img src={data?.images[5]} alt="img6" className="touch-image big" />
          </div>
        </div>

        <div className="form-container">
          <form className="get-in-touch-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="input-details">
              <input
                type="text"
                placeholder="First Name"
                className="input-field"
                {...register("firstName", { required: true })}
                required
              />
              <input
                type="text"
                placeholder="Last Name"
                className="input-field"
                {...register("lastName", { required: true })}
                required
              />
              <input
                type="email"
                placeholder="Email"
                className="input-field"
                {...register("email", { required: true })}
                required
              />
              <input
                type="tel"
                placeholder="+1 213 456 789"
                className="input-field"
                {...register("number", { required: true })}
                required
              />
              <textarea
                placeholder="Message"
                className="input-field"
                {...register("message")}
                rows={4}
              />
              {/* <input
                type="text"
                placeholder="State"
                className="input-field"
                {...register("state", { required: true })}
                required
              />
              <input
                type="text"
                placeholder="Country"
                className="input-field"
                {...register("country", { required: true })}
                required
              /> */}
              <button
                type="submit"
                className={`submit-button ${!isValid ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={!isValid}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default GetInTouch;
